export default __webpack_public_path__ + "static/media/aws.ef6fb669.svg";